import React, { FC } from "react";
import CompleteIcon from "../icons/CompleteIcon/CompleteIcon";

interface CarProgressStepperSectionProps {
  currentStep: number;
  setCurrentStep: (step: number) => void;
}
interface Step {
  id: number;
  label: string;
  status: "completed" | "active" | "inactive";
}
const CarProgressStepperSection: FC<CarProgressStepperSectionProps> = ({
  currentStep = 1,
  setCurrentStep,
}) => {
  const steps: Step[] = [
    { id: 1, label: "Vehicle & Add-ons", status: "completed" },
    { id: 2, label: "Enter your details", status: "active" },
    { id: 3, label: "Finish", status: "inactive" },
  ];
  return (
    <div className="flex items-center justify-center max-w-[1336px] mx-auto  px-4 my-6 border-b pb-6">
      <div className="flex items-center space-x-4 w-full">
        {steps.map((step, index) => {
          const isCompleted = index < currentStep;
          const isCurrent = index === currentStep;
          const isLast = index === steps.length - 1;

          return (
            <React.Fragment key={index}>
              <div
                className={`flex items-center ${
                  step.id !== 1 && "cursor-pointer"
                }`}
                onClick={() => {
                  if (step.id === 1) {
                    return;
                  }
                  if (isCompleted && index + 1 === currentStep + 1) {
                    return;
                  }
                  if (isCompleted) {
                    setCurrentStep(step.id - 1);
                  }
                }}
              >
                <div
                  className={`min-w-6 min-h-6 rounded-xl flex items-center justify-center 
                    ${
                      isCompleted || isCurrent ? "bg-secondary" : "bg-[#edf1f3]"
                    } 
                    ${isCurrent ? "border-2 border-[#eac1bd]" : ""}
                  `}
                >
                  <span
                    className={`text-xs font-semibold 
                      ${
                        isCompleted || isCurrent
                          ? "text-white"
                          : "text-[#66797f]"
                      }
                    `}
                  >
                    {isCompleted ? <CompleteIcon /> : index + 1}
                  </span>
                </div>
                <span
                  className={`ms-2 text-sm font-semibold text-nowrap
                  ${
                    isCompleted || isCurrent
                      ? isCurrent
                        ? "text-[#333333]"
                        : "text-secondary"
                      : "text-[#66797f]"
                  }
                `}
                >
                  {step.label}
                </span>
              </div>

              {!isLast && (
                <div
                  className={`w-full h-px 
                    ${
                      index < currentStep - 1
                        ? "border-t border-secondary"
                        : index === currentStep - 1
                        ? "border-t border-secondary"
                        : "border-t border-dashed border-[#66797f]"
                    }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default CarProgressStepperSection;
